var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('warning',{attrs:{"tree-title":"竞争对手","body-title":"竞争对手预警","category-field":_vm.categoryField}})}
var staticRenderFns = []

export { render, staticRenderFns }